"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.datadogTransport = void 0;
const utils_1 = require("./utils");
const browser_logs_1 = require("@datadog/browser-logs");
/**
 * A transport that sends logs to Datadog.
 * Note: This requires the datadog reporter to be initialized for it to work.
 */
function datadogTransport(config = {}) {
    const transport = {
        ...config,
        log: ({ level, message, ...metadata }) => {
            // Datadog expects a string message.
            browser_logs_1.datadogLogs.logger[level]((0, utils_1.getLogMessage)(message), metadata);
        },
    };
    return transport;
}
exports.datadogTransport = datadogTransport;
//# sourceMappingURL=datadogTransport.js.map